import React, { useState, useEffect } from "react";
import AppBar from '@mui/material/AppBar';

import Toolbar from '@mui/material/Toolbar';
import { Box, Container, Grid, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import axios from 'axios';


const ExhibitionNavbar = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid')
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        color_code_four: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        workshopBannerImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        online_status: "",
        bank_status: "",
        cash_status: "",
        free_status: "",
        eventLogo: "",
        error_list: [],

    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })
    }, [eventid]);


    //const SCFMSLOGO = `${process.env.PUBLIC_URL}/Abstract/loginBanerImage/SCFMS2024-logo.png`;
    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar sx={{
                        background: abstractHomeSetup.color_code
                            ? abstractHomeSetup.color_code
                            : 'linear-gradient(90deg, rgba(20, 65, 102, 1) 0%, rgba(20, 66, 103, 1) 36%, rgba(7, 25, 39, 1) 100%)'
                    }}>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                        >

                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            {/* <img  src={SCFMSLOGO}
                        alt="Logo"
                        sx={{
                            width: { xs: '150px', sm: '50px', md: '200px' }, // Responsive width
                            height: { xs: '75px', sm: '87.5px', md: '100px' }, // Responsive height
                            borderRadius: '50%',
                        }} /> */}
                            <Grid item xs={12} sm={4} lg={4}>
                                {
                                    abstractHomeSetup.eventLogo == undefined ?
                                        <span>No Logo Uploaded</span> :
                                        <><img src={`${abstractHomeSetup.base_url}/homepage/${abstractHomeSetup.eventLogo}`} sx={{
                                            width: { xs: '150px', sm: '50px', md: '200px' }, // Responsive width
                                            height: { xs: '75px', sm: '87.5px', md: '100px' }, // Responsive height
                                            borderRadius: '50%',
                                        }} />
                                        </>
                                }
                            </Grid>
                        </Typography>
                        <Button onClick={() => history.push('/')} color="inherit">Home</Button>
                        <Button onClick={() => history.push('/login')} color="inherit">Login</Button>
                    </Toolbar>
                </AppBar>
            </Box>
          
        </div>
    );
}

export default ExhibitionNavbar;
